// Riferimento alla timbratura suggerita che ha generato la push.
// Catturato PRIMA che ProtectedRoute rediriga (parametri persi al redirect verso /login).
const KEY = "orbit_push_pending";

export function capturePushLink() {
  try {
    const p = new URLSearchParams(window.location.search);
    const slot = p.get("push_slot");
    if (!slot) return;
    sessionStorage.setItem(KEY, JSON.stringify({
      slot_id: slot, kind: p.get("push_kind") || "in", date: p.get("push_date") || "",
    }));
    p.delete("push_slot"); p.delete("push_kind"); p.delete("push_date");
    const qs = p.toString();
    window.history.replaceState({}, "", window.location.pathname + (qs ? "?" + qs : ""));
  } catch (_) {}
}

export function setPushPending(obj) {
  try { sessionStorage.setItem(KEY, JSON.stringify(obj)); } catch (_) {}
}

export function takePushPending() {
  try {
    const v = sessionStorage.getItem(KEY);
    if (v) { sessionStorage.removeItem(KEY); return JSON.parse(v); }
  } catch (_) {}
  return null;
}
